import { render, staticRenderFns } from "./VenueDataList.vue?vue&type=template&id=1491ef9c&scoped=true"
import script from "./VenueDataList.vue?vue&type=script&lang=js"
export * from "./VenueDataList.vue?vue&type=script&lang=js"
import style0 from "./VenueDataList.vue?vue&type=style&index=0&id=1491ef9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1491ef9c",
  null
  
)

export default component.exports